import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { emptyRouter, RouterPayload } from "../types";

export const CSV_HEADERS = [
  "Nome",
  "Modo",
  "IP de origem",
  "Amostragem IPv4",
  "Amostragem IPv6",
  "IP SNMP",
  "Comunidade SNMP",
  "Porta SNMP",
];

const CSV_EXAMPLES = [
  [
    "Roteador exemplo 01",
    "nfcapd",
    "10.0.0.1",
    "1000",
    "1000",
    "10.0.0.1",
    "public",
    "161",
  ],
  [
    "Roteador exemplo 02",
    "sfcapd",
    "10.0.0.2",
    "2000",
    "2000",
    "10.0.0.2",
    "public",
    "161",
  ],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  nome: "name",
  name: "name",
  modo: "mode",
  mode: "mode",
  ipdeorigem: "sourceIp",
  ipdeorigemrouter: "sourceIp",
  iporigem: "sourceIp",
  sourceip: "sourceIp",
  amostragemipv4: "mostragemIpv4",
  mostragemipv4: "mostragemIpv4",
  amostragemipv6: "mostragemIpv6",
  mostragemipv6: "mostragemIpv6",
  ipsnmp: "snmpIp",
  snmpip: "snmpIp",
  comunidadesnmp: "snmpCommunity",
  comunidade: "snmpCommunity",
  snmpcommunity: "snmpCommunity",
  portasnmp: "snmpPort",
  porta: "snmpPort",
  snmpport: "snmpPort",
  fabricante: "fabricante",
  modelo: "modelo",
};

export function routersFromCsv(text: string): RouterPayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyRouter,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template Roteadores.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
